module.exports = __webpack_public_path__ + "static/media/img-msg-pre-goal.b72b9888.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-msg-pre-goal.svg
// module id = 1065
// module chunks = 0